export default __webpack_public_path__ + "static/media/noise.77d72c26.jpg";